import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ENYCGAMES_LOGO_URL } from '@config/brandTokens';

interface EncycGamesLogoProps {
  /** Display width in px (brand guideline: 220–240 desktop header) */
  width?: number;
  /** Navigate here on click; defaults to `/` */
  homePath?: string;
  sx?: object;
}

/** Primary EncycGames brand logo — use instead of Encycdata logo in app shells. */
const EncycGamesLogo: React.FC<EncycGamesLogoProps> = ({
  width = 230,
  homePath = '/',
  sx = {},
}) => {
  return (
    <Box
      component={RouterLink}
      to={homePath}
      aria-label="EncycGames home"
      title="Home"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        textDecoration: 'none',
        border: 'none',
        background: 'none',
        padding: 0,
        cursor: 'pointer',
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        component="img"
        src={ENYCGAMES_LOGO_URL}
        alt="EncycGames"
        sx={{
          width: `${width}px`,
          maxWidth: '100%',
          height: 'auto',
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </Box>
  );
};

export default EncycGamesLogo;
